(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function kickstartHeroVideos() {
      document.querySelectorAll('.hero__media-grid video').forEach(function (video) {
        if (!video.muted) return; // user already enabled sound, don't touch
        video.muted = true;
        video.autoplay = true;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', kickstartHeroVideos);
    } else {
      kickstartHeroVideos();
    }
    window.addEventListener('pageshow', kickstartHeroVideos);
  })();

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-hero-sound-toggle]');
    if (!toggle) return;

    var container = toggle.closest('.hero__container');
    var grid = container && container.querySelector('.hero__media-grid');
    if (!grid) return;

    var videos = grid.querySelectorAll('video');
    var icon = toggle.querySelector('.hero__sound-icon');
    var willUnmute = videos.length > 0 && videos[0].muted;

    videos.forEach(function (video) {
      video.muted = !willUnmute;
      if (willUnmute) {
        video.play().catch(function () {});
      }
    });

    toggle.setAttribute('aria-pressed', String(willUnmute));
    toggle.setAttribute('aria-label', willUnmute ? 'Silenciar' : 'Activar sonido');
    if (icon) icon.textContent = willUnmute ? '🔊' : '🔇';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
